import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

const deviceIcons = [
    ["access", `access`],
    ["cctv", `cctv`],
    ["climate", `climate`],
    ["fan", `fan`],
    ["fireplace", `fireplace`],
    ["garage", "garage"],
    ["gate", "gate"],
    ["lighting", `light`],
    ["music", `music`],
    ["security", `security`],
    ["sensors", `sensors`],
    ["shades", `shades`],
    ["water", `water-valve`],
    ["z-wave", `z-wave`],
];

@Injectable({
    providedIn: "root",
})
export class MatIconLoaderService {
    constructor(private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {}

    importIcons(icons: string[][]) {
        icons.forEach(([icon, filepath]) =>
            this.matIconRegistry.addSvgIcon(icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/${filepath}.svg`))
        );
    }

    getDeviceIcons() {
        return deviceIcons.map(icon => [`device-icon-${icon[0]}`, `device-categories/${icon[1]}`]);
    }
}
